"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPlusCircleIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("./fa-icons/icons");
const fontawesome_icon_1 = require("./fontawesome-icon");
const StyledPlusCircleIcon = () => ((0, jsx_runtime_1.jsx)(fontawesome_icon_1.FontAwesomeIcon, { icon: {
        icon: icons_1.faCirclePlus,
    }, sx: { fontSize: "12px" } }));
exports.StyledPlusCircleIcon = StyledPlusCircleIcon;
